import Vogue from '../assets/images/brand/vogue.png';
import Gq from '../assets/images/brand/gq.png';
import Elle from '../assets/images/brand/elle.png';
import Mint from '../assets/images/brand/mint.png';
import BombayTimes from '../assets/images/brand/bombay-times.png';
import Cnbc from '../assets/images/brand/cnbc.png';
import Dna from '../assets/images/brand/dna.png';
import Et from '../assets/images/brand/et.png';
import Femina from '../assets/images/brand/femina.png';
import Forbes from '../assets/images/brand/forbes.png';
import Fortune from '../assets/images/brand/fortune.png';
import Ht from '../assets/images/brand/ht.png';
import IndiaToday from '../assets/images/brand/india-today.png';
import MidDay from '../assets/images/brand/mid-day.png';
import Outlook from '../assets/images/brand/outlook.png';
import Rai from '../assets/images/brand/rai.png';
import TheTimesGroup from '../assets/images/brand/the-times-group.png';

export const brandRecognition = [
  {
    image: Vogue,
    alt: 'Vogue',
  },
  {
    image: Gq,
    alt: 'Gq',
  },
  {
    image: Elle,
    alt: 'Elle',
  },
  {
    image: Mint,
    alt: 'Mint',
  },
  {
    image: BombayTimes,
    alt: 'BombayTimes',
  },
  {
    image: Cnbc,
    alt: 'Cnbc',
  },
  {
    image: Dna,
    alt: 'Dna',
  },
  {
    image: Et,
    alt: 'Et',
  },
  {
    image: Femina,
    alt: 'Femina',
  },
  {
    image: Forbes,
    alt: 'Forbes',
  },
  {
    image: Fortune,
    alt: 'Fortune',
  },
  {
    image: Ht,
    alt: 'Ht',
  },
  {
    image: IndiaToday,
    alt: 'IndiaToday',
  },
  {
    image: MidDay,
    alt: 'MidDay',
  },
  {
    image: Outlook,
    alt: 'Outlook',
  },
  {
    image: Rai,
    alt: 'Rai',
  },
  {
    image: TheTimesGroup,
    alt: 'TheTimesGroup',
  },

];
